/*
 * File: ui-submit-converter.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-18 07:34:03
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    IUITagInput,
    IUITagResult,
    EUITagTarget,
    UITag,
    EUITagRuleType,
    EUITagRuleUnion,
} from "../core";

// @uiSubmitConverter - convert the result value to another for submittion.

@UITag.set()
export class uiSubmitConverter extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormSubmit];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Custom];
    allowNullRule: boolean = false;

    parse(input: IUITagInput): IUITagResult | null {
        const rule = this.parseRule(input);
        /// return when undefined.
        if (rule === undefined) return null;

        return {
            specials: {
                submitConverter: rule as any,
            },
        };
    }
}
